<div class="manage-membership-page">
  <HomeNavBar />

  <div class="container-fluid py-4 py-lg-5 pb-extra mb-5">
    <div class="row justify-content-center">
      <div class="col-12 col-xl-11">
        <div
          class="d-flex align-items-center justify-content-between gap-3 flex-wrap mb-4"
        >
          <div class="d-flex align-items-center gap-3">
            <button
              class="btn rounded-circle p-2 d-flex align-items-center justify-content-center membership-view-back-btn"
              @click="go_back"
            >
              <i class="bi bi-arrow-left fs-4"></i>
            </button>
            <div>
              <h1 class="text-dark mb-1 fw-bold marketplace-toolbar-title">
                My Subscription
              </h1>
            </div>
          </div>
        </div>

        <div
          v-if="payment_history_loading"
          class="d-flex flex-column align-items-center justify-content-center text-center checkout-summary-panel"
        >
          <div class="spinner-border text-primary mb-3" role="status"></div>
          <p class="text-xs text-muted mb-0">Loading membership details...</p>
        </div>

        <div v-else-if="has_current_membership">
          <div
            class="membership-payment-plan-card manage-membership-single-card mb-4"
          >
            <div>
              <div class="row g-4 align-items-start">
                <div class="col-12">
                  <div class="fw-bold mb-2">
                    Current Plan
                  </div>

                  <div class="d-flex align-items-center gap-2 flex-wrap mb-2 w-100">
                    <h4 class="fw-bold mb-0 text-capitalize">
                      {{ current_membership?.membership_type?.name }}
                    </h4>
                    <span
                      class="badge ms-auto"
                      :class="is_active ? 'task-chip task-chip-status' : 'task-due-chip d-inline-flex align-items-center fw-500 task-due-chip-overdue'"
                    >
                      <i class="bi bi-circle-fill text-xxxs me-1"></i>
                      {{ is_active ? 'active' : 'inactive'}}
                    </span>
                  </div>

                  <p v-if="current_membership?.description" class="text-muted mb-0 text-xxs">
                    {{(this.current_membership?.description || '')}}
                  </p>
                </div>
              </div>

              <hr class="my-4" />

              <div class="row g-3 align-items-stretch">
                <div class="col-md-12">
                  <div
                    class="membership-payment-summary-item h-100 d-flex align-items-center w-100"
                  >
                    <div class="d-flex align-items-center gap-3 min-w-0">
                      <div class="membership-payment-summary-icon">
                        <i class="bi bi-calendar-check text-primary"></i>
                      </div>

                      <div class="min-w-0">
                        <div class="fw-bold text-small mb-1">
                          Billing
                        </div>
                        <div class="fw-bold text-muted text-xs">
                          {{ billing_cycle || '--' }}
                        </div>
                      </div>
                    </div>

                    <div class="ms-auto text-end">
                      <div class="fw-bold text-small mb-1">
                        Price
                      </div>
                      <div class="fw-bold text-muted text-xs">
                        {{ format_currency(current_membership?.membership_pricing?.[0]?.price) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row g-4 mt-4 manage-membership-inner-grid">
            <div class="col-lg-8">
              <div class="membership-payment-detail-card h-100">
                <div>
                  <div class="membership-payment-detail-row mb-4">
                    <div>
                      <div class="d-flex align-items-start gap-3">
                        <div
                          class="membership-payment-summary-icon text-primary"
                        >
                          <i class="bi" :class="cancel_at_period_end ? 'bi-calendar-x' : 'bi-calendar-event'"></i>
                        </div>
                        <div>
                          <p class="fw-bold text-xs mb-1">
                            {{ cancel_at_period_end ? 'Last day of access' : 'Next renewal' }}
                          </p>
                          <p class="fw-bold text-muted text-xs mb-0">
                            {{ format_display_date(renewal_date) }}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div class="d-flex align-items-start justify-content-end gap-3 text-end">
                        <div
                          class="membership-payment-summary-icon text-primary"
                        >
                           <i class="bi" :class="cancel_at_period_end ? 'bi-arrow-repeat' : 'bi-cash-stack'"></i>
                        </div>
                        <div>
                          <p class="fw-bold text-xs mb-1">
                            {{ cancel_at_period_end ? 'Renewal status' : 'Next charge' }}
                          </p>
                          <p class="fw-bold text-muted text-xs mb-0">
                            {{
                              cancel_at_period_end
                                ? 'Will not renew'
                                : format_currency(current_membership?.membership_pricing?.[0]?.price)
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="membership-payment-divider"></div>

                  <p class="membership-payment-section-title mb-3">Included perks this cycle</p>

                  <ul
                    v-if="current_membership?.membership_perks && current_membership.membership_perks.length"
                    class="list-unstyled membership-payment-perks mb-0"
                  >
                    <li
                      v-for="perk in current_membership?.membership_perks"
                      :key="perk.id"
                    >
                      <i class="bi bi-check-lg"></i>
                      <span>{{ perk.perk.name }}</span>
                    </li>
                  </ul>
                  <p v-else class="text-muted small fst-italic mb-0">No perks listed for this membership.</p>
                </div>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="membership-payment-action-card h-100">
                <div class="d-flex flex-column">
                  <div class="d-flex align-items-center gap-2 mb-1">
                    <span
                      class="d-inline-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                    >
                      <i class="bi bi-info-circle-fill small"></i>
                    </span>

                    <h6 class="membership-payment-section-title mb-0">
                      Need to make changes?
                    </h6>
                  </div>
                  <p class="text-muted text-xs mb-0">
                    {{
                      cancel_at_period_end
                        ? `Your membership will not renew. Access ends ${format_display_date(renewal_date)}.`
                        : 'You can update your plan or cancel anytime.'
                    }}
                  </p>

                  <div class="d-grid gap-3 mt-2">
                    <button class="btn membership-payment-submit" type="button" @click="open_membership_card">
                      <span>Membership Card</span>
                      <i class="bi bi-chevron-right"></i>
                    </button>
                    <button
                      class="btn membership-payment-submit"
                      @click="navigate_to_plans"
                    >
                      <span>Upgrade Plan</span>
                      <i class="bi bi-chevron-right"></i>
                    </button>
                    <button
                      class="btn cancel-subscription-submit"
                      :disabled="cancel_at_period_end"
                      @click="cancel_membership">
                      <span>{{ cancel_at_period_end ? `Cancelled — access ends ${format_display_date(renewal_date)}` : 'Cancel' }}</span>
                      <i class="bi bi-chevron-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-else
          class="d-flex flex-column align-items-center justify-content-center text-center checkout-summary-panel"
        >
          <i class="bi bi-patch-question fs-2 text-primary mb-3"></i>
          <h2 class="h5 fw-bold text-dark mb-2">No active membership found</h2>
          <p class="text-xs text-muted mb-0">
            We could not find membership details for this user yet.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div id="membershipCardModal" class="modal fade" tabindex="-1" aria-labelledby="membershipCardModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered membership-card-dialog">
      <div class="modal-content border-0 rounded-4 overflow-hidden">
        <div class="modal-header border-0 px-4 pt-4 pb-2">
          <div>
            <h5 id="membershipCardModalLabel" class="modal-title fw-bold">Membership card</h5>
            <p class="text-muted text-xs mb-0">Present this card at member venues for access.</p>
          </div>
          <button type="button" class="btn-close" aria-label="Close" @click="close_membership_card"></button>
        </div>
        <div class="modal-body membership-card-modal-body px-4 pt-3 pb-4">
          <div v-if="membership_card_loading" class="text-center py-5">
            <div class="spinner-border text-primary mb-3" role="status"></div>
            <p class="text-muted text-xs mb-0">Loading membership card...</p>
          </div>
          <div v-else-if="membership_card_error" class="alert alert-danger text-xs mb-0" role="alert">
            <i class="bi bi-exclamation-circle me-2"></i>{{ membership_card_error }}
          </div>
          <div v-else-if="membership_card" class="membership-card-content">
            <div class="digital-membership-card">
              <div class="digital-membership-card-orb digital-membership-card-orb-top"></div>
              <div class="digital-membership-card-orb digital-membership-card-orb-bottom"></div>
              <i class="bi bi-wifi digital-membership-contactless"></i>

              <div class="digital-membership-card-member">
                <div class="digital-membership-card-label">Member</div>
                <h4 class="digital-membership-card-member-name">{{ membership_card.member?.full_name }}</h4>
              </div>

              <div class="digital-membership-card-details">
                <div class="mb-3">
                  <div class="digital-membership-card-label">Member ID</div>
                  <div class="digital-membership-card-number">{{ membership_card.card_number }}</div>
                </div>
                <div>
                  <div class="digital-membership-card-label">Valid thru</div>
                  <div class="digital-membership-card-validity">{{ membership_card_valid_thru() }}</div>
                </div>
              </div>

              <span class="digital-membership-card-tier">{{ membership_card_name() }}</span>
            </div>

            <div class="digital-membership-qr-panel mt-3">
              <img v-if="membership_card_qr" :src="membership_card_qr" class="digital-membership-qr-image" alt="Scannable membership card QR code" />
              <div v-else class="text-center text-muted py-5">
                <i class="bi bi-qr-code fs-1"></i>
                <p class="text-xs mb-0 mt-2">QR code unavailable</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
